import API from "@aws-amplify/api";
import { isMobileOnly } from "react-device-detect";

/**
 * get a xsolla checkout url for a given sku
 */
export const fetchXsollaCheckoutUrlForSkuOfType = (
  xsollaSku:any,
  xsollaProductId:any,
  purchaseType:any,
  // userAccessToken:any,
  userEmail: string
):Promise<any> => {
  return new Promise((resolve, reject) => {
    let deviceType = "desktop";
    if (isMobileOnly) {
      deviceType = "mobile";
    }
    let purchaseParams =
      "/assetmanagement/accountless/checkouturl?sku=" +
      xsollaSku +
      "&purchaseType=" +
      purchaseType +
      "&deviceType=" +
      deviceType +
      "&webhook=true" +
      "&userEmail=" +
      `${encodeURIComponent(userEmail)}`;
    if (xsollaProductId) {
      purchaseParams += "&productId=" + xsollaProductId;
    }
    if (process.env.REACT_APP_XSOLLA_ENV !== "production") {
      purchaseParams += "&sandbox=true";
    }
    //console.log("generating xsolla token with ", purchaseParams);
    API.get("assetsURL", purchaseParams, {
      headers: {
        "Content-Type": "application/json",
        // Token: userAccessToken,
      },
      response: true,
    })
      .then((res) => {
        //console.log("got xsolla checkout url response: ", res);
        if (res.status === 200 || res.status === 201) {
          resolve(res.data);
        } else {
          reject(
            new Error("Unexpected response from server, code="+ res.status)
          );
        }
      })
      .catch((error) => {
        console.log("error trying to get xsolla checkout url: ", error);
        if (error.response.status >= 400 && error.response.status <= 499) {
          reject(error.response);
        }
        if (error.response) {
          reject(error.response.data.error);
        } else {
          reject(new Error("Unexpected response from server: "+ error));
        }
      });
  });
};

export const fetchSaleData = (saleId:any):Promise<bb.model.sale.ISaleData|null> => {
  return new Promise((resolve, reject) => {
    const URL = saleId ? `/sales/${saleId}` : "/sales";

    API.get("userAccountManagementURL", URL, {
      headers: {
        "Content-Type": "application/json",
      },
      response: true,
    })
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          // console.log(res.data.payload);
          if (res.data.metadata.errorcode === "ENTITY_NOT_FOUND") {
            // no active sale
            resolve(null);
          } else {
            resolve(res.data.payload);
          }
        } else {
          reject(
            new Error(
              "Unexpected response from server, please try again later."
            )
          );
        }
      })
      .catch((error) => {
        console.log("fetchSaleData error: ", error);
        console.log("fetchSaleData error.response? ", error.response);
        // switched to a 200 + error message response for no-active-sale
        // if (error && error.response && error.response.status === 404) {
        //   console.log("no sale right now");
        //   return resolve(null);
        // }
        console.log("fetchSaleData non-404 error: ", error);

        if (error.response && error.response.data) {
          reject(error.response.data.error);
        } else {
          reject(
            new Error("Unexpected response from server, code="+ error.code)
          );
        }
      });
  });
};
